export const Confirm = {
    OPEN: "confirm.open",
    CLOSE: "confirm.close",
};
